export default function sendGaEvent(eventLabel, isNonInteraction = false, method = 'click') {
  if (window.gtag) {
    window.gtag('event', method, {
      event_category: window.location.pathname,
      event_label: eventLabel,
      non_interaction: isNonInteraction,
    });
  }
}
